import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
import React from "react";
import Svg from "@dcl/shared-components/dist/components/Svg";
var largeIconViewBox = "0 0 64 64";
var smallIvonViewBox = "0 0 24 24";

var Icon = function Icon(props) {
  return (
    /*#__PURE__*/
    // @ts-ignore
    React.createElement(Svg, props, props.children)
  );
};

var SvgContainer = function SvgContainer(_ref) {
  var children = _ref.children,
      props = _objectWithoutProperties(_ref, ["children"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg"
  }, props), children);
};

export default function withIconComponent(displayName) {
  var isLarge = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
  var viewBox = isLarge ? largeIconViewBox : smallIvonViewBox;

  var iconBuilder = function iconBuilder(SvgIcon) {
    var IconContainer = function IconContainer(props) {
      return /*#__PURE__*/React.createElement(Icon, props, /*#__PURE__*/React.createElement(SvgContainer, {
        viewBox: viewBox
      }, /*#__PURE__*/React.createElement(SvgIcon, null)));
    };

    IconContainer.displayName = displayName;
    IconContainer.svg = /*#__PURE__*/React.createElement("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: viewBox
    }, /*#__PURE__*/React.createElement(SvgIcon, null));
    return IconContainer;
  };

  return iconBuilder;
}